import React from "react";

export default class RecommendCourses extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_course_collections: {},
    };

    this.back = this.back.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.onCourseCollectionChange = this.onCourseCollectionChange.bind(this);
    this.onExperienceLevelChange = this.onExperienceLevelChange.bind(this);
  }

  render() {
    var self = this;

    var questionNumber = 1;

    var courseCollectionGroupSections =
      this.props.course_collection_groups_for_survey.map(function (data) {
        return self.renderCourseCollectionSection(data, questionNumber++);
      });

    return (
      <div className="recommend-courses">
        <form method="post" action={this.props.path}>
          <h1>Recommendation Questions</h1>

          {courseCollectionGroupSections.length > 0
            ? courseCollectionGroupSections
            : null}

          {this.props.course_collections.length > 0
            ? this.renderCourseCollectionSection(
                {
                  course_collection_group: {
                    id: -1,
                    survey_name: "financial topics",
                  },
                  course_collections: this.props.course_collections,
                },
                questionNumber++
              )
            : null}

          <div className="buttons">
            <div className="pull-left">
              <div className="previous">
                <a
                  href="#"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      this.back(e);
                    }
                  }}
                  onClick={this.back}
                  className="btn"
                >
                  <span className="fa fa-angle-left">&nbsp;</span> Back
                </a>
              </div>
            </div>
            <div className="pull-right">
              <button type="submit" className="btn btn-primary">
                Get recommendations
              </button>
            </div>
            <div className="clearfix">&nbsp;</div>
          </div>
          <span
            className="fa fa-times"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                this.back(e);
              }
            }}
            onClick={this.back}
          >
            &nbsp;
          </span>
        </form>
      </div>
    );
  }

  renderCourseCollectionSection(data, questionNumber) {
    var self = this;
    var choices = data.course_collections.map(function (course_collection) {
      return self.renderChoice(course_collection);
    });

    return (
      <div
        className="course-collection-section"
        key={data.course_collection_group.id}
      >
        <h2 className="number-and-question">
          <span className="question">
            {questionNumber ? (
              <span className="question-number">{questionNumber}.</span>
            ) : null}{" "}
            Which of the following{" "}
            <span className="course-collection-name">
              {data.course_collection_group.survey_name}
            </span>{" "}
            are of importance to you?
          </span>
          <h3 className="accent">Choose all that apply</h3>
          <div className="choices">{choices}</div>
        </h2>
      </div>
    );
  }

  renderChoice(course_collection) {
    return (
      <div className="row" key={course_collection.id}>
        <div className="label">
          <label>
            <input
              type="radio"
              onChange={this.onCourseCollectionChange}
              name={course_collection.id}
              value={course_collection.id}
              checked={this.isSelected(course_collection.id)}
            />{" "}
            {course_collection.name}{" "}
          </label>
          {this.isSelected(course_collection.id) ? (
            <span className="rate-your-experience">
              How would you rate your knowledge of this topic?
            </span>
          ) : null}
        </div>
        <div
          className="experience-level"
          style={{
            display: this.isSelected(course_collection.id) ? "block" : "none",
          }}
        >
          <label>
            <input
              type="radio"
              onChange={this.onExperienceLevelChange}
              checked={this.isExperienceLevelSelected(
                course_collection.id,
                "beginner"
              )}
              name={"course_collection_" + course_collection.id}
              value="beginner"
            />{" "}
            Beginner
          </label>
          <label>
            <input
              type="radio"
              onChange={this.onExperienceLevelChange}
              checked={this.isExperienceLevelSelected(
                course_collection.id,
                "intermediate"
              )}
              name={"course_collection_" + course_collection.id}
              value="intermediate"
            />{" "}
            Intermediate
          </label>
          <label>
            <input
              type="radio"
              onChange={this.onExperienceLevelChange}
              checked={this.isExperienceLevelSelected(
                course_collection.id,
                "advanced"
              )}
              name={"course_collection_" + course_collection.id}
              value="advanced"
            />{" "}
            Advanced
          </label>
          {this.renderExperienceLevelDefault(course_collection)}
        </div>
      </div>
    );
  }

  renderExperienceLevelDefault(course_collection) {
    if (
      this.isExperienceLevelSelected(course_collection.id, "beginner") ||
      this.isExperienceLevelSelected(course_collection.id, "intermediate") ||
      this.isExperienceLevelSelected(course_collection.id, "advanced")
    ) {
      return null;
    } else if (this.isSelected(course_collection.id)) {
      return (
        <input
          type="hidden"
          name={"course_collection_" + course_collection.id}
          value="beginner"
        />
      );
    }
  }

  isExperienceLevelSelected(course_collection_id, experience_level) {
    for (var i in this.state.selected_course_collections) {
      if (i == course_collection_id) {
        if (
          this.state.selected_course_collections[i].experience_level ===
          experience_level
        ) {
          return true;
        } else {
          return false;
        }
      }
    }

    return false;
  }

  isSelected(course_collection_id) {
    for (var i in this.state.selected_course_collections) {
      if (i == course_collection_id) {
        return true;
      }
    }

    return false;
  }

  back(e) {
    e.preventDefault();
    e.stopPropagation();

    window.history.back();
  }

  onCourseCollectionChange(e) {
    if (this.isSelected(e.target.value)) {
      // de-select if possible

      var course_collections = this.state.selected_course_collections;
      delete course_collections[e.target.name];
      this.setState({ selected_course_collections: course_collections });
    } else {
      // select

      var course_collections = this.state.selected_course_collections;
      course_collections[e.target.name] = {
        experience_level: null,
      };
      this.setState({ selected_course_collections: course_collections });
    }
  }

  onExperienceLevelChange(e) {
    var course_collection_id = e.target.name.split("course_collection_")[1];

    if (this.isExperienceLevelSelected(course_collection_id, e.target.value)) {
      // de-select if possible

      var course_collections = this.state.selected_course_collections;
      if (course_collections[course_collection_id]) {
        course_collections[course_collection_id].experience_level = null;
      }
      this.setState({ selected_course_collections: course_collections });
    } else {
      // select

      var course_collections = this.state.selected_course_collections;
      if (course_collections[course_collection_id]) {
        course_collections[course_collection_id].experience_level =
          e.target.value;
      }
      this.setState({ selected_course_collections: course_collections });
    }
  }
}
